//-----------------------
// React basic Components
//-----------------------
  import React                                               from "react";
//-----------------------------
// @material-ui/core components
//-----------------------------
  import TextField                                           from '@material-ui/core/TextField';
  import Autocomplete                                        from "@material-ui/lab/Autocomplete";
  import LocationOnIcon                                      from "@material-ui/icons/LocationOn";
  import Grid                                                from "@material-ui/core/Grid";
  import Typography                                          from "@material-ui/core/Typography";
  import { makeStyles }                                      from "@material-ui/core/styles";
  import parse                                               from "autosuggest-highlight/parse";
  import throttle                                            from "lodash/throttle";
//------------
// WebServices
//------------
//import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
//import { wu_Utilities }                                    from "../../_services";

function loadScript(src, position, id) {
    if (!position) {
        return;
    }

    const script = document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("id", id);
    script.setAttribute("crossorigin", "");
    script.src = src;
    position.appendChild(script);
}

const autocompleteService = { current: null, details:null };

const useStyles = makeStyles((theme) => ({
    icon: {
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
    },
}));

//------------
//translations
//------------
let texts_gr = wu_StaticDataService.wu_getLocales_gr({});
let texts_en = wu_StaticDataService.wu_getLocales_en({});
function NSInforString(aKey){
  if(localStorage.getItem("lang")==="en"){ return texts_en[aKey] ? texts_en[aKey] : ""; }
  else                                   { return texts_gr[aKey] ? texts_gr[aKey] : ""; }
};

// function uuidv4() {
//     return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
//         (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16),
//     );
// }

const sessionTokenTimestampTimeout = 1000 * 60 * 2.5;

let sessionToken;
let sessionTokenTimestamp;

export default function GeocodingsAutocomplete({ textField1b_hasError,textField1b_inputValue,onChange,onInputChange }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(null);
    const [inputValue, setInputValue] = React.useState(textField1b_inputValue); console.log("GeocodingsAutocomplete textField1b_inputValue="+textField1b_inputValue);
    const [options, setOptions] = React.useState([]);
    const loaded = React.useRef(false);

    if (typeof window !== "undefined" && !loaded.current) {
        if (!document.querySelector("#google-maps")) {
            loadScript(
                "https://maps.googleapis.com/maps/api/js?key=AIzaSyDKV9UZQGYyi_A71qdgwaoVtnb-aHcdfbw&libraries=places",
                document.querySelector("head"),
                "google-maps",
            );
        }
        loaded.current = true;
    }
    // React.useEffect(() => { setHasError(textField1b_hasError)}, [textField1b_hasError] );

    const fetch = React.useMemo(
        () =>
            throttle((request, callback) => {
                autocompleteService.current.getPlacePredictions(request, callback);
            }, 200),
        [],
    );

    React.useEffect(() => {
        console.log("React.useEffect-01-01");
        let active = true;

        if (!autocompleteService.current && window.google) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
            autocompleteService.details = new window.google.maps.places.PlacesService(document.getElementById("wbwugooglemapsid"));
          //autocompleteService.geocode = new window.google.maps.Geocoder();
        }
        if (!autocompleteService.current) {
            return undefined;
        }
        if (inputValue === "") {
            setOptions(value ? [value] : []);
            return undefined;
        }
        if (!sessionToken || Date.now() - sessionTokenTimestamp > sessionTokenTimestampTimeout) {
            sessionToken = new window.google.maps.places.AutocompleteSessionToken();//uuidv4();
            sessionTokenTimestamp = Date.now();
        }
        fetch({ input: inputValue, sessionToken: sessionToken, componentRestrictions:{country:'gr'}, types:['geocode'] }, (results) => {
            if (active) {
                let newOptions = [];

                if (value) {
                    newOptions = [value];
                }
                if (results) {
                    newOptions = [...newOptions, ...results];
                }
                setOptions(newOptions);
            }
        });
        console.log("React.useEffect-01-02");
        return () => {
            active = false;
        };
    }, [value, inputValue, fetch]);

    React.useEffect(() => {
        console.log("React.useEffect-02-01");
        if (autocompleteService.current && autocompleteService.details && value && value.place_id) {
          autocompleteService.details.getDetails({placeId:value.place_id, sessionToken:sessionToken, fields:['geometry']}, (res) => {
            //console.log(res);
            //sessionToken = null;//new window.google.maps.places.AutocompleteSessionToken();//uuidv4();
            //sessionTokenTimestamp = 0;//Date.now();
            onChange && onChange({lat:res.geometry.location.lat(),lng:res.geometry.location.lng()});
          });
        }
        else{
          onChange && onChange({lat:null,lng:null});
        }
  //}, [inputValue, value, options]);
    }, [value]);

    console.log("React.useEffect-02-02");
    return (
        <Autocomplete
            id="textField1b_autocomplete"
            style={{ marginTop:15 }}
            getOptionLabel={(option) => (typeof option === "string" ? option : option.description)}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            inputValue={textField1b_inputValue}
            onChange={(event, newValue) => {
                setOptions(newValue ? [newValue, ...options] : options);
                setValue(newValue);
                //console.log("GeocodingsAutocomplete onChange");
            }}
            freeSolo
            // onKeyPress={(event, newValue) => {
            //     setOptions(newValue ? [newValue, ...options] : options);
            //     setValue(newValue);
            // }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
                onInputChange(newInputValue);
                //console.log("GeocodingsAutocomplete onInputChange");
            }}
            renderInput={(params) => (
                <TextField {...params} error={textField1b_hasError} label={NSInforString("StoreLocator_plh1b")} variant="outlined" fullWidth />
            )}
            renderOption={(option) => {
                const matches = option.structured_formatting.main_text_matched_substrings;
                const parts = parse(
                    option.structured_formatting.main_text,
                    matches.map((match) => [match.offset, match.offset + match.length]),
                );

                return (
                    <Grid container alignItems="center">
                        <Grid item>
                            <LocationOnIcon className={classes.icon} />
                        </Grid>
                        <Grid item xs>
                            {parts.map((part, index) => (
                                <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>{part.text}</span>
                            ))}
                            <Typography variant="body2" color="textSecondary">
                                {option.structured_formatting.secondary_text}
                            </Typography>
                        </Grid>
                    </Grid>
                );
            }}
        />
    );
}
